import React from 'react'
import { SkyTvSvg } from '@mobi/component-library/Assets/Svg/SkyTv'
import { ChannelType } from '@mobi/component-library/Assets/Svg/SkyTv/SkyTvSvg'
import { StatusBadge } from '@mobi/component-library/Feedback/StatusBadge'

export const SkyTvBadge: React.FC<{
  channel: ChannelType
  size?: 'S' | 'M'
}> = ({ channel, size = 'S' }) => (
  <StatusBadge color={channel === 'Sky1' ? 'red' : channel === 'Sky2' ? 'blue' : 'gray'}>
    <SkyTvSvg channel={channel} width={size == 'S' ? '2rem' : '2.4rem'} />
  </StatusBadge>
)
